import styled from "styled-components";
import { MEDIA_QUERY } from "../../../entities/Common";

export const MixtureTabItemStyled = styled.div`
  width: 100px;
  text-align: center;
  margin-right: 10px;
  .mixture-item {
    &__photo {
      width: 100px;
      height: 100px;
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
    &__name {
      font-size: 12px;
    }
  }

  @media (max-width: ${MEDIA_QUERY.LAPTOP}) {
    width: 90px;
    .mixture-item {
      &__photo {
        width: 90px;
        height: 90px;
      }
    }
  }
`;
